import React from 'react';
import './App.css';
import Home from './Home';
import Header from './Header';
import Card from './Card';
function App() {
  return (
    <div className="App">
     <Header />
     <Home />
     <Card />

    </div>
  );
}

export default App;
